module.exports = __webpack_public_path__ + "static/react-logo-580ffd26ccaa16481ed87c1829c74943.png";